// extracted by mini-css-extract-plugin
module.exports = {"modal":"style_modal__1U7Tz","paper":"style_paper__SYulH","content":"style_content__2Lx4x","title":"style_title__2fMKq","dash":"style_dash__1V0Mk"};